<template>
    <div>
        <div class="col-sm-12">

            <div class="row">
                <div class="col-6">
                    <div class="c-field">
                        <label class="c-field__label" for="segment.name">Friendly Name</label>
                        <input v-model="phoneNumber.friendly_name" class="c-input" type="text">
                    </div>
                </div>

                <div class="col-6">
                    <div class="c-field">
                        <label class="c-field__label" for="segment.name">Inbound call strategy</label>
                        <v-select placeholder="Select..."
                            :model-value="selectedInboundStrategyLabel"
                            :options="inboundStrategies"
                            @update:model-value="inboundStrategySelected"
                            :clearable="false"
                        >
                        </v-select>
                    </div>
                </div>
            </div>


            <div class="row">
                <div v-if="selectedInboundStrategy == 'say'" class="col-6 col-lg-offset-6">
                    <div class="c-field">
                        <label class="c-field__label" for="segment.name">On call, say this message:</label>
                        <textarea v-model="phoneNumber.voice_message_text" class="c-input"></textarea>
                    </div>
                </div>

                <div v-if="selectedInboundStrategy == 'play'" class="col-6 col-lg-offset-6">
                    <div class="row">
                        <div :class="[phoneNumber.voice_message_url ? 'col-lg-7' : 'col-lg-12', '']">
                            <div class="c-field">
                                <label class="c-field__label">On call, play this recording:</label>
                                <vx-drop-zone
                                    ref="mediaDropzone"
                                    :multiple="false"
                                    :maxFiles="1"
                                    :maxSize="1000000"
                                    :fileTypes="['audio/*']"
                                    @added="dropzoneFileAdded"
                                    @error="dropzoneError"
                                />
                            </div>
                        </div>

                        <div v-if="phoneNumber.voice_message_url" class="col-lg-5">
                            <a :href="filteredVoiceMessageUrl" target="_blank" class="media_url pull-right">
                                [ Play Audio File ]
                            </a>
                        </div>
                    </div>

                </div>
            </div>

            <div v-if="selectedInboundStrategy == 'forward'" class="row">
                <div class="col-6">
                    <div class="c-field">
                        <label class="c-field__label" for="segment.name">On call, forward to #</label>
                        <input v-model="phoneNumber.forward_voice_to" class="c-input" type="text">
                    </div>
                </div>

                <div class="col-6">
                    <div class="c-field">
                        <label class="c-field__label" for="segment.name">Press digits after forward (optional)</label>
                        <input v-model="phoneNumber.forward_voice_send_digits" class="c-input" type="text">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="c-field u-mt-medium">
                        <label for="useForSending">Use For Sending:&nbsp;</label>
                        <input v-model="phoneNumber.use_for_sending" value="1" type="checkbox" id="useForSending" :checked="phoneNumber.use_for_sending">
                    </div>
                </div>
            </div>

            <div class="row u-mt-small">
                <div class="col-12">
                    <a v-if="phoneNumber.id" href="#" class="pull-right u-ml-small c-btn c-btn--success" @click.prevent="update">
                        Update Phone Number
                        <i v-if="formIsSubmitting" class="fa fa-spin fa-circle-o-notch"></i>
                    </a>

                    <a href="#" class="c-btn c-btn--secondary pull-right" @click.prevent="close">Cancel</a>
                </div>
            </div>

        </div><!-- eo c-card -->


    </div>
</template>

<script>
import VSelect from 'vue-select';
import { VxDropZone } from '@voxie/frontend-components-v3';
import { messageMediaClient } from '../../services';
import { mediaUrlFilter } from '../filters';

export default {
    props: ['phoneNumber'],

    components: {
        VSelect,
        VxDropZone,
    },

    inject: ['FEATURES'],

    data() {
        const inboundStrategies = [
            {value: 'default', label: 'Say a system message indicating no voice service'},
            {value: 'forward', label: 'Forward call to another number'},
            {value: 'say', label: 'Say the given message'},
            {value: 'play', label: 'Play recorded message'},
        ];

        if (this.FEATURES.shift_to_text) {
            inboundStrategies.push({value: 'shift_to_text', label: 'Shift to Text'});
        }

        return {
            selectedInboundStrategyLabel: null,
            selectedInboundStrategy: null,
            inboundStrategies,
            formIsSubmitting: false,
            mediaFileUploadedComplete: false,
            isUploadingFile: false,
        };
    },

    created(){
        Bus.$on('phone_numbersResourceErrors', () => {
            this.formIsSubmitting = false;
        });
    },

    mounted() {
        if (this.phoneNumber.inbound_call_handler === 'shift_to_text') {
            this.selectedInboundStrategy = 'shift_to_text';
            this.selectedInboundStrategyLabel = this.inboundStrategies.find(opt => opt.value == 'shift_to_text')?.label;
        } else if (!this.phoneNumber.play_recorded_voice_message && this.phoneNumber.forward_voice_to){
            this.selectedInboundStrategy = 'forward';
            this.selectedInboundStrategyLabel = this.inboundStrategies.filter(opt => opt.value == 'forward')[0].label;
            this.phoneNumber.play_recorded_voice_message = false;
        } else if (this.phoneNumber.play_recorded_voice_message && this.phoneNumber.voice_message_url){
            this.selectedInboundStrategy = 'play';
            this.selectedInboundStrategyLabel = this.inboundStrategies.filter(opt => opt.value == 'play')[0].label;
            this.phoneNumber.play_recorded_voice_message = true;
        } else if(!this.phoneNumber.play_recorded_voice_message && this.phoneNumber.voice_message_text){
            this.selectedInboundStrategy = 'say';
            this.selectedInboundStrategyLabel = this.inboundStrategies.filter(opt => opt.value == 'say')[0].label;
            this.phoneNumber.play_recorded_voice_message = false;
        } else {
            this.selectedInboundStrategy = 'default';
            this.selectedInboundStrategyLabel = this.inboundStrategies.filter(opt => opt.value == 'default')[0].label;
        }
    },

    computed: {
        filteredVoiceMessageUrl() {
            return mediaUrlFilter(this.phoneNumber.voice_message_url);
        },
    },

    methods: {
        close() {
            Bus.$emit('phone_numbersCancelEdit', this.phoneNumber.id);
        },

        update() {
            if (this.isUploadingFile) {
                Swal.fire({
                    title: 'File upload in progress',
                    html: 'Your file is being uploaded, please wait for it to finish.',
                    icon: 'info',
                });

                return;
            }

            this.phoneNumber.phone_number = null; //kill b/c we are only update.

            this.formIsSubmitting = true;

            Bus.$emit('phone_numbersUpdate', this.phoneNumber.id, JSON.parse(JSON.stringify(this.phoneNumber)));
        },

        dropzoneFileAdded(file) {
            this.isUploadingFile = true;
            const teamId = Spark.state.currentTeam.id;

            let formData = new FormData();
            formData.append('file', file.file);

            messageMediaClient.uploadMedia(teamId, formData, (progressEvent) => {
                let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                this.updateUploadProgress(file, percentCompleted);
            })
            .then((response) => {
                this.$refs.mediaDropzone.clearFiles();
                this.mediaFileUploadedComplete = true;
                this.phoneNumber.voice_message_url = response.data.url;
            })
            .finally(() => {
                this.isUploadingFile = false;
            });
        },

        dropzoneError(message) {
            Swal.fire({
                title: 'Oops...',
                html: message,
                icon: 'error'
            });

            this.mediaFileUploadedComplete = false;
        },

        updateUploadProgress(file, progress) {
            this.$refs.mediaDropzone.updateProgress(file, progress);
        },

        inboundStrategySelected(attr) {
            if(attr instanceof Object){
                if(attr.value != undefined){
                    this.selectedInboundStrategyLabel = attr.label;
                    this.selectedInboundStrategy = attr.value;

                    switch (attr.value) {
                    case 'forward':
                        this.phoneNumber.play_recorded_voice_message = false;
                        this.phoneNumber.voice_message_text = null;
                        this.phoneNumber.inbound_call_handler = 'core';
                        break;

                    case 'play':
                        this.phoneNumber.play_recorded_voice_message = true;
                        this.phoneNumber.voice_message_text = null;
                        this.phoneNumber.forward_voice_to = null;
                        this.phoneNumber.forward_voice_send_digits = null;
                        this.phoneNumber.inbound_call_handler = 'core';
                        break;

                    case 'say':
                        this.phoneNumber.play_recorded_voice_message = false;
                        this.phoneNumber.forward_voice_to = null;
                        this.phoneNumber.forward_voice_send_digits = null;
                        this.phoneNumber.inbound_call_handler = 'core';
                        break;

                    case 'shift_to_text':
                        this.phoneNumber.play_recorded_voice_message = false;
                        this.phoneNumber.forward_voice_to = null;
                        this.phoneNumber.forward_voice_send_digits = null;
                        this.phoneNumber.voice_message_text = null;
                        this.phoneNumber.inbound_call_handler = 'shift_to_text';
                        break;

                    case 'default':
                        this.phoneNumber.play_recorded_voice_message = false;
                        this.phoneNumber.voice_message_text = null;
                        this.phoneNumber.voice_message_url = null;
                        this.phoneNumber.forward_voice_to = null;
                        this.phoneNumber.forward_voice_send_digits = null;
                        this.phoneNumber.inbound_call_handler = 'core';
                        break;
                    }
                }
            }
        },
    }
};
</script>

<style>
.media_url{
    width: auto;
    margin: 95px 45px 0px 0px;
    padding: 3px;
}
.row{
    margin-top: 10px;
    margin-bottom: 10px;
}
.c-field__label{
    margin: 0 0 0 1px;
}
.dropzone .dz-preview .dz-error-message{
    top: 150px;
}
.c-switch__label {
    min-width: 325px;
}
.switch-col{
    margin-top: 1.45rem !important;
}
</style>
